import { useState, useCallback, useMemo } from "react";
import { getLocationDetails, getLocationList } from "../services/locationService";

const useLocation = () => {
  const [listStatus, setListStatus] = useState("idle"); // idle | loading | done | error
  const [detailStatus, setDetailStatus] = useState("idle");
  const [error, setError] = useState("");
  const [data, setData] = useState([]);
  const [single, setSingle] = useState(null);

  const fetchLocationList = useCallback(async (payload) => {
    setListStatus("loading");
    setError("");

    try {
      const response = await getLocationList(payload);

      if (response?.status !== "Error") {
        setData(response.data ?? response);
        setListStatus("done");
      } else {
        setListStatus("error");
        setError(response?.message || "Something went wrong");
      }
    } catch (err) {
      setListStatus("error");
      setError(err?.message || "Something went wrong");
    }
  }, []);

  const fetchLocationDetails = useCallback(async (targetId) => {
    setDetailStatus("loading");
    setError("");

    try {
      const response = await getLocationDetails(targetId);

      if (response?.status !== "Error") {
        setSingle(response.data ?? response);
        setDetailStatus("done");
      } else {
        setDetailStatus("error");
        setError(response?.message || "Something went wrong");
      }
    } catch (err) {
      setDetailStatus("error");
      setError(err?.message || "Something went wrong");
    }
  }, []);

  const resetStatus = useCallback(() => {
    setListStatus("idle");
    setDetailStatus("idle");
    setError("");
  }, []);

  return {
    fetchLocationList,
    fetchLocationDetails,
    data,
    single,
    listStatus,
    detailStatus,
    error,
    resetStatus,
  };
};

export default useLocation;
